import { render, staticRenderFns } from "./video-button-white.vue?vue&type=template&id=66e5c966&scoped=true"
import script from "./video-button-white.vue?vue&type=script&lang=js"
export * from "./video-button-white.vue?vue&type=script&lang=js"
import style0 from "./video-button-white.vue?vue&type=style&index=0&id=66e5c966&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e5c966",
  null
  
)

export default component.exports